module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-attachment-wrapper">\r\n	<div class="b-attachment-avia b-attachment-rail">\r\n		<div class="b-attachment-avia__wrapper">\r\n			<div class="b-search-form__params">\r\n				<span class="b-search-form__param-classes b-railways-custom-toggle">\r\n					<span class="js-widget"  onclick=\'return new Widgets.ToggleButtonDouble({ bindingProperty: "classOfService", valueFirst: "ECONOMY", valueSecond: "BUSINESS", labelFirst: L10N.get("pages.search.searchForm.economy"), labelSecond: L10N.get("pages.search.searchForm.business") })\'></span>\r\n				</span>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div>\r\n';

}
return __p
}